// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteConfirmationPopup.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { propTypes as MobxPropTypes } from 'mobx-react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.ImportOverwriteConfirmationPopupAction';
import { map, split, uniqueId, forEach } from 'lodash/fp';
import ImportOverwriteOptionTree from './Izenda.ImportOverwriteOptionTree';

@connect(actions)
export default class ImportOverwriteConfirmationPopup extends Component {

  static propTypes = {
    overwriteOptionTree: MobxPropTypes.arrayOrObservableArray
  };

  renderBody() {
    const { localization, overwriteOptionTree } = this.props;
    const messages = split('\n', localization.getText('IMPORT_OVERWRITE_CONFIMATION_POPUP_DESCRIPTION'));

    return (
      <div className="izenda-ImportOverwriteConfirmationPopup">
        {map(
          message => (
            <div key={uniqueId('mes')}>
              <label>{message}</label>
            </div>
          ),
          messages
        )}
        <ImportOverwriteOptionTree overwriteOptionTree={overwriteOptionTree} />
      </div>
    );
  }

  onClosing = (callBack: any, type: string) => {
    const overwriteOption = [];
    forEach(node => node.updateOverwriteOption(overwriteOption), this.props.overwriteOptionTree);
    this.props.onClosing(overwriteOption, type);
  };

  render() {
    const props = this.props;
    const { localization } = props;

    return (
      <Popup visible onClosing={this.onClosing} type="none" autoClose={false}>
        <Popup.Header
          tooltip={localization.getText('IMPORT_OVERWRITE_CONFIMATION_POPUP_TOOLTIP')}
          title={localization.getText('IMPORT_OVERWRITE_CONFIMATION_POPUP_TITLE')}
        />
        <Popup.Body>{this.renderBody()}</Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton key="accept" type="accept">
            {localization.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
          <Popup.ConfirmationButton key="cancel" type="cancel">
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportOverwriteConfirmationPopup.js